





import { defineComponent } from '@nuxtjs/composition-api';
import { SfCircleIcon } from '@storefront-ui/vue';

export default defineComponent({
  name: 'VideoButton',
  components: {
    SfCircleIcon
  }
});
